<template>
  <div class="font" >
    <b-container fluid>
      <b-row>
        <b-col cols='12' class='mx-auto mt-4 ml-3 font-org-right-blue'>
          <h4><b-icon icon="files" class='mr-2'></b-icon>求人作成 / 編集</h4>
        </b-col>
      </b-row>
      <b-row class='mt-2 px-0 py-3'>
        <b-col cols='8' class='mx-auto'>
          <b-row class='mt-4 pb-2'>
            <b-col cols="12" class='px-0 text-center'>
              <h4 class="org_title" v-if='jobId == undefined'>{{$t("message.create_joboffer")}}</h4>
              <h4 class="org_title" v-else>求人編集</h4>
              <p v-if='is_error' class="erro">
                入力内容に誤りがあります。<br>
                確認してもう一度入力してください。
              </p>
            </b-col>
          </b-row>

          <div v-if='!jobConfirm'>
            <validation-observer class="form" ref="obs" v-if='!jobConfirm'>

              <validation-provider name="job_title_name" rules="required">
                <div slot-scope="TitleProps">
                  <b-row class='mt-4 pt-1'>
                    <p class="require-org-badge px-2">{{$t("message.required")}}</p><h5>求人名</h5>

                    <b-form-input v-model="registInfo.title" placeholder='例) 求人名'></b-form-input>
                    <p v-if="TitleProps.failed" class="error">{{ TitleProps.errors[0] }}</p>
                  </b-row>
                </div>
              </validation-provider>

              <validation-provider name="org_industry" rules="required">
                <div slot-scope="CatchCopyProps">
                  <b-row class='mt-4 pt-1'>
                    <p class="require-org-badge px-2">{{$t("message.required")}}</p><h5>業種</h5>
                    <b-form-select v-model="registInfo.industry" class='dirty' :options="INDUSTRY_OPTIONS"></b-form-select>
                    <p v-if="CatchCopyProps.failed" class="error">{{ CatchCopyProps.errors[0] }}</p>
                  </b-row>
                </div>
              </validation-provider>

            <b-row class='mt-4 pt-1'>
              <p class="require-org-badge px-2">{{$t("message.required")}}</p><h5>職種</h5>
            </b-row>
            <b-row>
              <b-col class='px-0' cols='6'>
                <validation-provider name="occupation" rules="required">
                  <div slot-scope="OccupationProps">
                    <b-form-select v-model="registInfo.occupation" class='dirty' :options="INDUSTRY_OCCUPATION[registInfo.industry]"></b-form-select>
                    <p v-if="OccupationProps.failed" class="error">{{ OccupationProps.errors[0] }}</p>
                  </div>
                </validation-provider>
              </b-col>
            </b-row>

            <b-row class='mt-4 pt-1'>
              <p class="require-org-badge px-2 mb-3">{{$t("message.required")}}</p><h5>給与</h5>
            </b-row>
            <b-row>
              <b-col cols='12' class='px-0'>
                <validation-provider name="qualification" rules="required">
                  <div slot-scope="SalaryTypeProps">
                    <b-form-radio-group
                      v-model="registInfo.employment_form"
                    >
                      <b-row class='pl-3'>
                        <b-col cols='3' v-for='row in salaryOptions' :key='row.value' class='pb-3 px-0'>
                          <span class="salary_status_radio p-2">
                            <b-form-radio :value='row.value' class=''>{{ row.text }}</b-form-radio>
                          </span>
                        </b-col>
                      </b-row>
                    </b-form-radio-group>
                    <p v-if="SalaryTypeProps.failed" class="error text-left">{{ SalaryTypeProps.errors[0] }}</p>
                  </div>
                </validation-provider>
                <b-row class='pl-3'>
                  <b-col cols='2' class='text-right pl-0'>
                    <validation-provider name="min_salary" rules="required">
                      <div slot-scope="MinSalaryProps">
                        <b-form-input type='number' v-model="registInfo.salary_from"></b-form-input>
                        <p v-if="MinSalaryProps.failed" class="error text-left">{{ MinSalaryProps.errors[0] }}</p>
                      </div>
                    </validation-provider>
                  </b-col>
                  <b-col cols='1' class='mt-2 px-0'>
                    {{ $t("message.ten_thousand_yen") }} 〜
                  </b-col>
                  <b-col cols='2'>
                    <b-form-input type='number' v-model="registInfo.salary_to"></b-form-input>
                  </b-col>
                  <b-col cols='1' class='mt-2 px-0'>
                    {{ $t("message.ten_thousand_yen") }}
                  </b-col>
                </b-row>
              </b-col>
              <small class="mt-3">
                仕事内容は法令に従って所定の労働条件等を明示する必要があります<br>
                法令上、最低限明示することが必要な労働条件等をご確認のうえ、仕事内容をご記載ください。（ご参考：厚生労働省・都道府県労働局「労働者を募集する企業の皆様へ」）<br>
                対象者の年齢、性別、社会的身分を限定する文言を使うと求人を掲載できないことがあります。<br>
                よくある掲載不可例：「20代歓迎」「年齢不問 (若手歓迎)」「女性歓迎・限定」「学生限定」<br>
              </small>
            </b-row>

            <validation-provider name="posting_time" rules="required">
              <div slot-scope="PostingTimeProps">
                <b-row class='mt-4 pt-1'>
                  <p class="require-org-badge px-2">{{$t("message.required")}}</p><h5>求人掲載日時</h5>

                </b-row>
                <b-row class=''>
                  <b-col cols='5' class='pl-0'>
                    <b-form-input v-model="posting_start_date" type='date'></b-form-input>
                  </b-col>
                  <b-col cols='5'>
                    <b-form-input v-model="posting_start_time" type='time'></b-form-input>
                  </b-col>
                  <p v-if="PostingTimeProps.failed" class="error">{{ PostingTimeProps.errors[0] }}</p>
                </b-row>
              </div>
            </validation-provider>

            <validation-provider name="posting_end_time" rules="required">
              <div slot-scope="PostingEndTimeProps">
                <b-row class='mt-4 pt-1'>
                  <h5>求人掲載終了日時</h5>
                </b-row>
                <b-row class=''>
                  <b-col cols='5' class='pl-0'>
                    <b-form-input v-model="posting_end_date" type='date'></b-form-input>
                  </b-col>
                  <b-col cols='5'>
                    <b-form-input v-model="posting_end_time" type='time'></b-form-input>
                  </b-col>
                  <p v-if="PostingEndTimeProps.failed" class="error">{{ PostingEndTimeProps.errors[0] }}</p>
                </b-row>
              </div>
            </validation-provider>

            <b-row class='mt-4 pt-1'>
              <p class="require-org-badge px-2">{{$t("message.required")}}</p><h5 >勤務時間</h5>
            </b-row>
            <b-row class=''>
              <b-textarea v-model="registInfo.working_hours" rows="5"></b-textarea> 
            </b-row>

            <b-row class='mt-4 pt-1'>
              <p class="require-org-badge px-2">{{$t("message.required")}}</p><h5 >勤務地</h5>
            </b-row>
            <b-row class=''>
              <b-col class='px-0' cols='12'>
                <validation-provider name="work_location" rules="required">
                  <div slot-scope="WorkLocationProps">
                    <b-form-input v-model="registInfo.location"></b-form-input>
                    <p v-if="WorkLocationProps.failed" class="error">{{ WorkLocationProps.errors[0] }}</p>
                  </div>
                </validation-provider>
              </b-col>
            </b-row>

            <b-row class='mt-4 pt-1'>
              <p class="optional-org-badge px-2 mb-1">{{$t("message.optional")}}</p><h5> 仕事内容及びアピールポイント </h5>
              <b-col cols='12' class='pl-0'>
                <p class="mb-1">POINT : 先にアピールポイントを伝えると求職者に関心を持ってもらいやすくなります</p>
                <b-form-textarea rows="6" v-model="registInfo.description"></b-form-textarea>
              </b-col>
            </b-row>

            <b-row class='mt-4 pt-1'>
              <p class="optional-org-badge px-2">{{$t("message.optional")}}</p><h5>応募資格</h5>
            </b-row>
            <b-row>
              <b-col cols='12' class='px-0'>
                <b-form-textarea rows="6" v-model="registInfo.qualification"></b-form-textarea>
              </b-col>
            </b-row>

            <b-row class='mt-4 pt-1'>
              <p class="optional-org-badge px-2 mb-2">{{$t("message.optional")}}</p><h5>求める人材</h5>
              <b-form-textarea rows="6" v-model="registInfo.human_resource"></b-form-textarea>
            </b-row>

            <b-row class='mt-4 pt-1'>
              <p class="require-org-badge px-2">{{$t("message.required")}}</p><h5>採用人数</h5><br>
            </b-row>
            <b-row>
              <b-col cols='4' class='px-0'>
                <validation-provider name="number_of_hires" rules="required">
                  <div slot-scope="NumberHiresProps">
                    <b-form-input type='number' v-model="registInfo.number_of_hires"></b-form-input>
                    <p v-if="NumberHiresProps.failed" class="error">{{ NumberHiresProps.errors[0] }}</p>
                  </div>
                </validation-provider>
              </b-col>
              <b-col cols='1' class='mt-2 px-1'>
                人
              </b-col>
            </b-row>

            <b-row class='mt-4 pt-1'>
              <p class="optional-org-badge px-2 mb-3">{{$t("message.optional")}}</p><h5>独身者・既婚者・不問</h5>
            </b-row>
            <b-row>
              <b-col cols='12' class='px-0'>
                <b-form-radio-group
                  v-model="registInfo.married_type"
                >
                  <b-row class='pl-3'>
                    <b-col cols='3' v-for='row in marriedOptions' :key='row.value' class='pb-3 px-0'>
                      <span class="salary_status_radio p-2">
                        <b-form-radio :value='row.value' class=''>{{ row.text }}</b-form-radio>
                      </span>
                    </b-col>
                  </b-row>
                </b-form-radio-group>
              </b-col>
            </b-row>

            <b-row class='mt-4 pt-1'>
              <p class="optional-org-badge px-2 mb-2">{{$t("message.optional")}}</p><h5> 日本語レベル </h5>
              <b-form-select v-model="registInfo.japanese_level" class='dirty' :options="japaneseOptions"></b-form-select>
            </b-row>

            <b-row class='mt-4 pt-1'>
              <p class="optional-org-badge px-2">{{$t("message.optional")}}</p><h5> 希望国籍 </h5>
              <b-form-select v-model="registInfo.hope_of_country" class='dirty' :options="hopeOptions"></b-form-select>
            </b-row>

            <b-row class='mt-4 pt-1'>
              <p class="optional-org-badge px-2 mb-3">{{$t("message.optional")}}</p><h5> 学歴 </h5>
            </b-row>
            <b-row>
              <b-col cols='12' class='px-0'>
                <b-form-radio-group
                  v-model="registInfo.educational_background"
                >
                  <b-row class='pl-3'>
                    <b-col cols='3' v-for='row in educationalOptions' :key='row.value' class='pb-3 px-0'>
                      <span class="salary_status_radio p-2">
                        <b-form-radio :value='row.value' class=''>{{ row.text }}</b-form-radio>
                      </span>
                    </b-col>
                  </b-row>
                </b-form-radio-group>
              </b-col>
            </b-row>

            <b-row class='mt-4 pt-1'>
              <p class="optional-org-badge px-2 mb-3">{{$t("message.optional")}}</p><h5>国外からの応募可否</h5>
              <b-col cols='12' class='px-0'>
                <b-form-radio-group
                  v-model="registInfo.apply_from_overseas"
                >
                  <b-row class='pl-3'>
                    <b-col cols='3' v-for='row in overseasOptions' :key='row.value' class='pb-3 px-0'>
                      <span class="salary_status_radio p-2">
                        <b-form-radio :value='row.value' class=''>{{ row.text }}</b-form-radio>
                      </span>
                    </b-col>
                  </b-row>
                </b-form-radio-group>
              </b-col>
            </b-row>

            <b-row class='mt-4 pt-1'>
              <p class="optional-org-badge px-2 mb-2">{{$t("message.optional")}}</p><h5>休憩時間</h5>
            </b-row>
            <b-row>
              <b-col cols='4' class='pl-0'>
                <b-form-select v-model="registInfo.break_time" class='dirty' :options="breakTimeOptions"></b-form-select>
              </b-col>
            </b-row>

            <b-row class='mt-4 pt-1'>
              <p class="optional-org-badge px-2">{{$t("message.optional")}}</p><h5>月残業時間</h5>
              <b-form-input v-model="registInfo.overtime" placeholder='例) 平均20時間'></b-form-input>
            </b-row>

            <b-row class='mt-4 pt-1'>
              <p class="optional-org-badge px-2">{{$t("message.optional")}}</p><h5>休日</h5>

              <b-form-input v-model="registInfo.holiday" placeholder='例) 土・日・祝日'></b-form-input>
            </b-row>

            <b-row class='mt-4 pt-1'>
              <p class="optional-org-badge px-2">{{$t("message.optional")}}</p><h5>労務管理担当者</h5>
              <b-form-input v-model="registInfo.wage_ledger_creator"></b-form-input>
            </b-row>

            <b-row class='mt-4 pt-1'>
              <p class="optional-org-badge px-2 mb-3">{{$t("message.optional")}}</p><h5>賃金台帳作成方法</h5>
            </b-row>
            <b-row>
              <b-col cols='12' class='px-0'>
                <b-form-radio-group
                  v-model="registInfo.way_create_wage_ledger"
                >
                  <b-row class='pl-3'>
                    <b-col cols='3' v-for='row in createWageOptions' :key='row.value' class='pb-3 px-0'>
                      <span class="salary_status_radio p-2">
                        <b-form-radio :value='row.value' class=''>{{ row.text }}</b-form-radio>
                      </span>
                    </b-col>
                  </b-row>
                </b-form-radio-group>
              </b-col>
            </b-row>


            <b-row class='mt-4 pt-1'>
              <p class="optional-org-badge px-2 mb-3">{{$t("message.optional")}}</p><h5>就労時間管理</h5>
            </b-row>
            <b-row>
              <b-col cols='12' class='px-0'>
                <b-form-radio-group
                  v-model="registInfo.working_time_management"
                >
                  <b-row class='pl-3'>
                    <b-col cols='3' v-for='row in timeManageOptions' :key='row.value' class='pb-3 px-0'>
                      <span class="salary_status_radio p-2">
                        <b-form-radio :value='row.value' class=''>{{ row.text }}</b-form-radio>
                      </span>
                    </b-col>
                  </b-row>
                </b-form-radio-group>
              </b-col>
            </b-row>

            <b-row class='mt-4 pt-1'>
              <p class="optional-org-badge px-2 mb-3">{{$t("message.optional")}}</p><h5>勤務時食事提供状況</h5>
            </b-row>
            <b-row>
              <b-col cols='12' class='px-0'>
                <b-form-radio-group
                  v-model="registInfo.meal_related"
                >
                  <b-row class='pl-3'>
                    <b-col cols='3' v-for='row in mealOptions' :key='row.value' class='pb-3 px-0'>
                      <span class="salary_status_radio p-2">
                        <b-form-radio :value='row.value' class=''>{{ row.text }}</b-form-radio>
                      </span>
                    </b-col>
                  </b-row>
                </b-form-radio-group>
              </b-col>
            </b-row>

            <b-row class='mt-4 pt-1' v-if='registInfo.meal_related == 2'>
              <p class="optional-org-badge px-2 mb-3">{{$t("message.optional")}}</p><h5>上記で弁当提供を選択した方</h5>
            </b-row>
            <b-row v-if='registInfo.meal_related == 2'>
              <b-col cols='2' class='pt-1 px-0'>
                毎月の徴収費用
              </b-col>
              <b-col cols='4' class='px-0'>
                <b-form-input type='number' v-model="registInfo.facilities_equipment" ></b-form-input>
              </b-col>
              <b-col cols='1' class='px-1 pt-1'>
                円
              </b-col>
            </b-row>

            <b-row class='mt-4 pt-1'>
              <p class="optional-org-badge px-2 mb-3">{{$t("message.optional")}}</p><h5>作業着</h5>
            </b-row>
            <b-row>
              <b-col cols='12' class='px-0'>
                <b-form-radio-group
                  v-model="registInfo.work_clothes"
                >
                  <b-row class='pl-3'>
                    <b-col cols='3' v-for='row in workClothOptions' :key='row.value' class='pb-3 px-0'>
                      <span class="salary_status_radio p-2">
                        <b-form-radio :value='row.value' class=''>{{ row.text }}</b-form-radio>
                      </span>
                    </b-col>
                  </b-row>
                </b-form-radio-group>
                <b-form-input v-if="registInfo.work_clothes==4" v-model="registInfo.work_clothes_other" ></b-form-input>
              </b-col>
            </b-row>

            <b-row class='mt-4 pt-1'>
              <p class="optional-org-badge px-2 mb-3">{{$t("message.optional")}}</p><h5>保護具</h5>
            </b-row>
            <b-row>
              <b-col cols='12' class='px-0'>
                <b-form-radio-group
                  v-model="registInfo.protective_equipment"
                >
                  <b-row class='pl-3'>
                    <b-col cols='3' v-for='row in workClothOptions' :key='row.value' class='pb-3 px-0'>
                      <span class="salary_status_radio p-2">
                        <b-form-radio :value='row.value' class=''>{{ row.text }}</b-form-radio>
                      </span>
                    </b-col>
                  </b-row>
                </b-form-radio-group>
                <b-form-input v-if="registInfo.protective_equipment==4" v-model="registInfo.protective_equipment_other" ></b-form-input>
              </b-col>
            </b-row>

            <b-row class='mt-4 pt-1'>
              <p class="optional-org-badge px-2">{{$t("message.optional")}}</p><h5>寮施設概要</h5>
              <b-form-input v-model="registInfo.accommodation_overview" placeholder="（例）中古アパート 会社まで徒歩１５分 1人1部屋を追加" ></b-form-input>
            </b-row>

            <b-row class='mt-4 pt-1'>
              <p class="optional-org-badge px-2 mb-3">{{$t("message.optional")}}</p><h5>寮施設場所</h5>
            </b-row>
            <b-row>
              <b-col cols='12' class='px-0'>
                <b-form-radio-group
                  v-model="registInfo.place"
                >
                  <b-row class='pl-3'>
                    <b-col cols='4' v-for='row in placeOptions' :key='row.value' class='pb-3 px-0'>
                      <span class="salary_status_radio p-2">
                        <b-form-radio :value='row.value' class=''>{{ row.text }}</b-form-radio>
                      </span>
                    </b-col>
                  </b-row>
                </b-form-radio-group>
              </b-col>
            </b-row>

            <b-row class='mt-4 pt-1'>
              <p class="optional-org-badge px-2">{{$t("message.optional")}}</p><h5>寮施設設名</h5>
              <b-form-input v-model="registInfo.accommodation_name" ></b-form-input>
            </b-row>

            <b-row class='mt-4 pt-1'>
              <p class="optional-org-badge px-2">{{$t("message.optional")}}</p><h5>寮施設所在地</h5>
              <b-form-input v-model="registInfo.accommodation_location" ></b-form-input>
            </b-row>

            <b-row class='mt-4 pt-1'>
              <p class="optional-org-badge px-2">{{$t("message.optional")}}</p><h5>部屋面積</h5>
            </b-row>
            <b-row>
              <b-col cols='4' class='px-0'>
                <b-form-input type='number' v-model="registInfo.room" ></b-form-input>
              </b-col>
              <b-col cols='1' class='px-1'>
                m<sup>2</sup>
              </b-col>
            </b-row>

            <b-row class='mt-4 pt-1'>
              <p class="optional-org-badge px-2">{{$t("message.optional")}}</p><h5>１部屋あたりの収容人数</h5>
            </b-row>
            <b-row>
              <b-col cols='4' class='px-0'>
                <b-form-input type='number' v-model="room_capacity" ></b-form-input>
              </b-col>
              <b-col cols='1' class='px-1'>
                名
              </b-col>
            </b-row>
            <b-row class='mt-4 pt-1'>
              <p class="optional-org-badge px-2">{{$t("message.optional")}}</p><h5>徴収費用 寮費</h5>
            </b-row>
            <b-row>
              <b-col cols='1' class='pl-3 pt-1'>
                月額
              </b-col>
              <b-col cols='4' class='px-0'>
                <b-form-input type='number' v-model="living_cost" ></b-form-input>
              </b-col>
              <b-col cols='1' class='px-1 pt-1'>
                円
              </b-col>
            </b-row>

            <b-row class='mt-4 pt-1'>
              <p class="optional-org-badge px-2 mb-3">{{$t("message.optional")}}</p><h5>徴収費用 水道光熱費</h5>
            </b-row>
            <b-row>
                <b-form-radio-group v-model="registInfo.utility_cost">
                  <b-row class='pl-3'>
                    <b-col cols='6' v-for='row in CollectionFeeOptions' :key='row.value' class='pb-3 px-0'>
                      <span class="salary_status_radio p-2 mr-4">
                        <b-form-radio :value='row.value' class=''>{{ row.text }}</b-form-radio>
                      </span>
                    </b-col>
                  </b-row>
                </b-form-radio-group>
            </b-row>

            <b-row class='mt-4 pt-1'>
              <p class="optional-org-badge px-2 mb-3">{{$t("message.optional")}}</p><h5>徴収費用 通信費</h5>
            </b-row>
            <b-row>
                <b-form-radio-group v-model="registInfo.communication_cost">
                  <b-row class='pl-3'>
                    <b-col cols='6' v-for='row in CollectionFeeOptions' :key='row.value' class='pb-3 px-0'>
                      <span class="salary_status_radio p-2 mr-4">
                        <b-form-radio :value='row.value' class=''>{{ row.text }}</b-form-radio>
                      </span>
                    </b-col>
                  </b-row>
                </b-form-radio-group>
            </b-row>

            <b-row class='mt-4 pt-1'>
              <p class="optional-org-badge px-2">{{$t("message.optional")}}</p><h5>交通アクセス(寮から職場までの通勤時間)</h5>
            </b-row>
            <b-row>
              <b-col cols='4' class='px-0'>
                <b-form-input type='number' v-model="access_minute" ></b-form-input>
              </b-col>
              <b-col cols='1' class='px-1 pt-1'>
                分
              </b-col>
            </b-row>

            <b-row class='mt-4 pt-1'>
              <p class="optional-org-badge px-2">{{$t("message.optional")}}</p><h5>交通アクセス(寮から職場までの通勤方法)</h5>

              <b-form-input v-model="access_way" placeholder='例) 自転車'></b-form-input>
            </b-row>

            <b-row class='mt-4 pt-1'>
              <p class="optional-org-badge px-2 mb-3">{{$t("message.optional")}}</p><h5>引越し代及び渡航費・国内移動費 負担有無</h5>
            </b-row>
            <b-row>
              <b-col cols='12' class='px-0'>
                <b-textarea rows="6" placeholder="（例）全額企業負担 又は 上限100,000円まで など" v-model="registInfo.moving_fee"></b-textarea> 
              </b-col>
            </b-row>

            <b-row class='mt-4 pt-1'>
              <p class="optional-org-badge px-2">{{$t("message.optional")}}</p><h5>待遇・福利厚生</h5>
              <b-form-input v-model="registInfo.walfare" placeholder=''></b-form-input>
            </b-row>

            <b-row class='mt-4 pt-1'>
              <p class="optional-org-badge px-2">{{$t("message.optional")}}</p><h5>その他</h5>
              <b-form-input v-model="registInfo.other" placeholder=''></b-form-input>
            </b-row>

            <b-row class='mt-4 pt-1'>
              <p class="optional-org-badge px-2">{{$t("message.optional")}}</p><h5>募集職種の作業風景写真（実際に撮ったもの）</h5>
            </b-row>
            <b-row>
              <b-col cols='3' class='pr-4' v-for='(image, index) in registInfo.images' :key='"image" + index'>
                <select-image :imaga_url='image' :index='index' :type='"image"' @addImage='addImage'></select-image>
              </b-col>
            </b-row>

            <b-row class='mt-4'>
              <p class="optional-org-badge px-2">{{$t("message.optional")}}</p><h5>採用までのフロー</h5>
              <b-form-textarea rows="6" v-model="registInfo.after_joining"></b-form-textarea>
            </b-row>

            <b-row class='mt-4'>
              <p class="optional-org-badge px-2">{{$t("message.optional")}}</p><h5>会社外写真</h5>
            </b-row>
            <b-row>
              <b-col cols='3' class='pr-4' v-for='(image, index) in registInfo.outside_office_image' :key='index'>
                <select-image :imaga_url='image' :index='index' :type='"outside_office"' @addImage='addImage'></select-image>
              </b-col>
            </b-row>

            <b-row class='mt-4'>
              <p class="optional-org-badge px-2">{{$t("message.optional")}}</p><h5>会社内写真</h5>
            </b-row>
            <b-row>
              <b-col cols='3' class='pr-4' v-for='(image, index) in registInfo.within_office_image' :key='index'>
                <select-image :imaga_url='image' :index='index' :type='"within_office"' @addImage='addImage'></select-image>
              </b-col>
            </b-row>

            <b-row class='mt-4'>
              <p class="optional-org-badge px-2">{{$t("message.optional")}}</p><h5>該当仕事写真</h5>
            </b-row>
            <b-row>
              <b-col cols='3' class='pr-4' v-for='(image, index) in registInfo.working_image' :key='index'>
                <select-image :imaga_url='image' :index='index' :type='"working"' @addImage='addImage'></select-image>
              </b-col>
            </b-row>

            <b-row class='mt-4'>
              <p class="optional-org-badge px-2">{{$t("message.optional")}}</p><h5>社員写真</h5>
            </b-row>
            <b-row>
              <b-col cols='3' class='pr-4' v-for='(image, index) in registInfo.employee_image' :key='index'>
                <select-image :imaga_url='image' :index='index' :type='"employee"' @addImage='addImage'></select-image>
              </b-col>
            </b-row>

            <b-row class='mt-4'>
              <p class="optional-org-badge px-2">{{$t("message.optional")}}</p><h5>寮部屋外写真</h5>
            </b-row>
            <b-row>
              <b-col cols='3' class='pr-4' v-for='(image, index) in registInfo.outside_dormitory_image' :key='index'>
                <select-image :imaga_url='image' :index='index' :type='"outside_dormitory"' @addImage='addImage'></select-image>
              </b-col>
            </b-row>

            <b-row class='mt-4'>
              <p class="optional-org-badge px-2">{{$t("message.optional")}}</p><h5>寮部屋内写真</h5>
            </b-row>
            <b-row>
              <b-col cols='3' class='pr-4' v-for='(image, index) in registInfo.within_dormitory_image' :key='index'>
                <select-image :imaga_url='image' :index='index' :type='"within_dormitory"' @addImage='addImage'></select-image>
              </b-col>
            </b-row>

            <b-row class='mt-4 text-center'>
              <b-col cols='5' class='mx-auto'>
                <b-button v-if='jobId == undefined' pill class='bg-orange' @click='next()'>{{$t("message.create")}}</b-button>
                <b-button v-else pill class='bg-orange' @click='next'>{{$t("message.edit")}}</b-button>
              </b-col>
            </b-row>
          </validation-observer>
          </div>
          <div v-else>
            <job-confirm :jobInfo='registInfo' @createJob='createJob' @back='notConfirm'></job-confirm>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import axios from 'axios';
import SelectImage from "@/components/SelectImage";
import JobConfirm from "@/components/Organization/Job/JobConfirm";
export default {
  components: {
    SelectImage,
    JobConfirm
  },
  data() {
    return {
      jobId: this.$route.params.jobId,
      registInfo: {
        title: '',
        state: '',
        industry_id: '',
        description: '',
        tags: '',
        salary_from: '',
        salary_to: '',
        salary: '',
        location: '',
        working_hours: '',
        employment_form: '',
        human_resource: '',
        access: '',
        walfare: '',
        other: '',
        catch_copy: '',
        occupation_category: '',
        company_name: '',
        target_time: '',
        images: [null],
        within_dormitory_image: [null],
        outside_dormitory_image: [null],
        employee_image: [null],
        working_image: [null],
        within_office_image: [null],
        outside_office_image: [null],
      },
      is_error: false,
      room_capacity: 0,
      room_per_person: 0,
      access_way: '',
      access_minute: '',
      living_cost: '',
      posting_start_time: '',
      posting_start_date: '',
      posting_end_time: '',
      posting_end_date: '',
      occupactionOptions: [
        { value: 'full', text: '職種1' },
        { value: 'part', text: '職種2' },
        { value: 'temporary', text: '職種3'},
        { value: 'contract', text: '職種4' },
      ],
      emStatusOptions: [
        { value: 'リフォーム', text: "リフォーム" },
        { value: '土木', text: '土木' },
        { value: '内装', text: '内装' },
      ],
      publicOptions: [
        { item: 'public', name: this.$i18n.t('message.public') },
        { item: 'private', name: this.$i18n.t('message.private') }
      ],
      salaryOptions: [
        { value: 'hourt', text: '時給' },
        { value: 'day', text: '日給' },
        { value: 'week', text: '週給'},
        { value: 'month', text: '月給' },
        { value: 'year', text: '年収' },
      ],
      marriedOptions: [
        { value: 'single', text: '独身者' },
        { value: 'married', text: '既婚者'},
        { value: 'couple', text: 'カップル・夫婦'},
        { value: 'no', text: '不問' },
      ],
      japaneseOptions: [
        { value: '1', text: 'N1' },
        { value: '2', text: 'N2' },
        { value: '3', text: 'N3' },
        { value: '4', text: 'N4' },
      ],
      hopeOptions: [
        { value: 'ベトナム', text: this.$i18n.t('message.vietnum') },
        { value: 'ラオス', text: this.$i18n.t('message.laos') },
        { value: 'マレーシア', text: this.$i18n.t('message.malaysia') },
        { value: 'バングラデッシュ', text: this.$i18n.t('message.bangladesh') },
        { value: 'インド', text: this.$i18n.t('message.indo') },
        { value: 'モンゴル', text: this.$i18n.t('message.mongol') },
        { value: 'ネパール', text: this.$i18n.t('message.nepal') },
        { value: 'インドネシア', text: this.$i18n.t('message.indonesia') },
        { value: 'タイ', text: this.$i18n.t('message.th') },
        { value: 'フィリピン', text: this.$i18n.t('message.philipine') },
        { value: 'ミャンマー', text: this.$i18n.t('message.my') },
        { value: 'ウズベキスタン', text: this.$i18n.t('message.uzbekistan') },
        { value: 'パキスタン', text: this.$i18n.t('message.pakistan') },
        { value: '日本', text: this.$i18n.t('message.japan') },
        { value: 'スリランカ', text: this.$i18n.t('message.srilank') },
        { value: 'カンボジア', text: this.$i18n.t('message.combodia') },
        { value: '不問', text: '不問' },

      ],
      educationalOptions: [
        { value: 'junior', text: '中卒以上' },
        { value: 'high', text: '高卒以上'},
        { value: 'uni', text: '大卒以上' },
        { value: 'no', text: '不問' },
      ],
      breakTimeOptions: [
        { value: '1', text: '11:00 ~ 12:00' },
        { value: '2', text: '12:00 ~ 13:00'},
        { value: '3', text: '13:00 ~ 14:00' },
        { value: '4', text: '14:00 ~ 15:00' },
      ],
      createWageOptions: [
        { value: '1', text: 'システム利用' },
        { value: '2', text: 'その他'},
      ],
      timeManageOptions: [
        { value: '1', text: 'タイムカード' },
        { value: '2', text: '手書き' },
        { value: '3', text: 'システム利用' },
      ],
      mealOptions: [
        { value: '1', text: '自炊' },
        { value: '2', text: '弁当提供(実費)'},
      ],
      workClothOptions: [
        { value: '1', text: '有り(貸与)' },
        { value: '2', text: '有り(指定服自己負担)'},
        { value: '3', text: 'なし' },
        { value: '4', text: 'その他' },
      ],
      overseasOptions: [
        { value: '1', text: '可能' },
        { value: '2', text: '不可' },
      ],
      CollectionFeeOptions: [
        { value: '1', text: '本人負担' },
        { value: '2', text: '会社負担' },
      ],
      placeOptions: [
        { value: '1', text: '会社敷地内' },
        { value: '2', text: '会社近隣借上(マンション)' },
        { value: '3', text: '会社近隣借上(アパート)' },
      ],
      movingOptions: [
        { value: '1', text: 'あり' },
        { value: '2', text: 'なし' },
      ],
      workTimeOptions: [
        { value: '1', text: '1:00' },
        { value: '2', text: '2:00' },
        { value: '3', text: '3:00' },
        { value: '4', text: '4:00' },
        { value: '5', text: '5:00' },
        { value: '6', text: '6:00' },
        { value: '7', text: '7:00' },
        { value: '8', text: '8:00' },
        { value: '9', text: '9:00' },
        { value: '10', text: '10:00' },
        { value: '11', text: '11:00' },
        { value: '12', text: '12:00' },
        { value: '13', text: '13:00' },
        { value: '14', text: '14:00' },
        { value: '15', text: '15:00' },
        { value: '16', text: '16:00' },
        { value: '17', text: '17:00' },
        { value: '18', text: '18:00' },
        { value: '19', text: '19:00' },
        { value: '20', text: '20:00' },
        { value: '21', text: '21:00' },
        { value: '22', text: '22:00' },
        { value: '23', text: '23:00' },
        { value: '24', text: '24:00' },
      ],
      idToken: localStorage.idToken,
      jobConfirm: false,
      isAgency: false
    }
  },
  methods: {
    deleteOffer(){
      axios
      .delete(process.env.VUE_APP_API + "/api/org/jobs/" + this.jobId, {headers: {'Authorization': 'Bearer ' + this.idToken}})
      .then(() => {
        alert('削除できました')
        this.$router.push("/organization/jobOffers")
      }).catch(error => {
        console.log('this is org error', error)
      })
    },
    notConfirm(){
      this.jobConfirm = false
    },
    checkAgency() {
      var idToken = localStorage.idToken
      axios.get(process.env.VUE_APP_API + "/api/agcy/agency/1", {headers: {'Authorization': 'Bearer ' + idToken}})
        .then(() => { this.isAgency = true})
    },
    addImage(data){
      var len = 0
      if(data.type == 'within_dormitory'){
        len = this.registInfo.within_dormitory_image.length
        if( data.index == len -1){
          this.registInfo.within_dormitory_image[len -1] = data.image
          this.registInfo.within_dormitory_image.push(null)
        }
        else{
          this.registInfo.within_dormitory_image[data.index] = data.image
          this.registInfo = Object.assign({}, this.registInfo)
        }
      }
      else if(data.type == 'outside_dormitory'){
        len = this.registInfo.outside_dormitory_image.length
        if( data.index == len -1){
          this.registInfo.outside_dormitory_image[len -1] = data.image
          this.registInfo.outside_dormitory_image.push(null)
        }
        else{
          this.registInfo.outside_dormitory_image[data.index] = data.image
          this.registInfo = Object.assign({}, this.registInfo)
        }
      }
      else if(data.type == 'employee'){
        len = this.registInfo.employee_image.length
        if( data.index == len -1){
          this.registInfo.employee_image[len -1] = data.image
          this.registInfo.employee_image.push(null)
        }
        else{
          this.registInfo.employee_image[data.index] = data.image
          this.registInfo = Object.assign({}, this.registInfo)
        }
      }
      else if(data.type == 'working'){
        len = this.registInfo.working_image.length
        if( data.index == len -1){
          this.registInfo.working_image[len -1] = data.image
          this.registInfo.working_image.push(null)
        }
        else{
          this.registInfo.working_image[data.index] = data.image
          this.registInfo = Object.assign({}, this.registInfo)
        }
      }
      else if(data.type == 'outside_office'){
        len = this.registInfo.outside_office_image.length
        if( data.index == len -1){
          this.registInfo.outside_office_image[len -1] = data.image
          this.registInfo.outside_office_image.push(null)
        }
        else{
          this.registInfo.outside_office_image[data.index] = data.image
          this.registInfo = Object.assign({}, this.registInfo)
        }
      }
      else if(data.type == 'within_office'){
        len = this.registInfo.within_office_image.length
        if( data.index == len -1){
          this.registInfo.within_office_image[len -1] = data.image
          this.registInfo.within_office_image.push(null)
        }
        else{
          this.registInfo.within_office_image[data.index] = data.image
          this.registInfo = Object.assign({}, this.registInfo)
        }
      }
      else if(data.type == 'image'){
        len = this.registInfo.images.length
        if( data.index == len -1){
          this.registInfo.images[len -1] = data.image
          this.registInfo.images.push(null)
        }
        else{
          this.registInfo.images[data.index] = data.image
          this.registInfo = Object.assign({}, this.registInfo)
        }
      }
    },
    next(){
      this.$refs.obs.validate().then(value =>{
        if(value){
          this.registInfo.facility = String(this.room_capacity)+ ',' + String(this.room_per_person)
          this.registInfo.collection_fee = String(this.living_cost)
          this.registInfo.access = String(this.access_minute) + ',' + String(this.access_way)
          this.registInfo.posting_time = this.posting_start_date + ',' + String(this.posting_start_time)
          this.registInfo.posting_end_time = this.posting_end_date + ',' + String(this.posting_end_time)


          var len = 0
          len = this.registInfo.images.length
          console.log(this.registInfo.images)
          if (this.registInfo.images[len -1] == null){
            this.registInfo.images.pop()
          }
          len = this.registInfo.within_office_image.length
          if (this.registInfo.within_office_image[len -1] == null){
            this.registInfo.within_office_image.pop()
          }
          len = this.registInfo.outside_office_image.length
          if (this.registInfo.outside_office_image[len -1] == null){
            this.registInfo.outside_office_image.pop()
          }
          len = this.registInfo.working_image.length
          if (this.registInfo.working_image[len -1] == null){
            this.registInfo.working_image.pop()
          }
          len = this.registInfo.employee_image.length
          if (this.registInfo.employee_image[len -1] == null){
            this.registInfo.employee_image.pop()
          }
          len = this.registInfo.outside_dormitory_image.length
          if (this.registInfo.outside_dormitory_image[len -1] == null){
            this.registInfo.outside_dormitory_image.pop()
          }
          len = this.registInfo.within_dormitory_image.length
          if (this.registInfo.within_dormitory_image[len -1] == null){
            this.registInfo.within_dormitory_image.pop()
          }

          if(this.registInfo.employment_form == "hourt") {
            this.registInfo.month_salary_from = this.registInfo.salary_from * 8 * 20
            this.registInfo.month_salary_to = this.registInfo.salary_to * 8 * 20
          }
          if(this.registInfo.employment_form == "week") {
            this.registInfo.month_salary_from = this.registInfo.salary_from * 4
            this.registInfo.month_salary_to = this.registInfo.salary_to * 4 
          }
          if(this.registInfo.employment_form == "year") {
            this.registInfo.month_salary_from = this.registInfo.salary_from / 12
            this.registInfo.month_salary_to = this.registInfo.salary_to / 12
          }
          if(this.registInfo.employment_form == "month") {
            this.registInfo.month_salary_from = this.registInfo.salary_from
            this.registInfo.month_salary_to = this.registInfo.salary_to
          }

          this.jobConfirm = true;
          this.is_error = false
        }
        else{
          this.is_error = true
        }
      })
    },
    createJob(){
      this.$store.commit('setLoading', true)
      if(this.jobId == undefined){
        axios
        .post(process.env.VUE_APP_API + "/api/org/jobs", {job: this.registInfo}, {headers: {'Authorization': 'Bearer ' + this.idToken}})
        .then(response => {
          console.log(response.data)
          this.$store.commit('setLoading', false)

          this.$swal.fire({
            icon: 'success',
            title: this.$i18n.t('message.change_success')
          }).then(() => {
            if(this.isAgency) {
              this.$router.push("/agency/jobOffers")
            } else {
              this.$router.push("/organization/jobOffers")
            }
          })

        }).catch(error => {
          console.log('this is org error', error)
        })
        // this.jobConfirm = true;
      }else{
        axios
        .patch(process.env.VUE_APP_API + "/api/org/jobs/" + this.jobId, {job: this.registInfo}, {headers: {'Authorization': 'Bearer ' + this.idToken}})
        .then(response => {
          console.log(response.data)
          this.$store.commit('setLoading', false)

          this.$swal.fire({
            icon: 'success',
            title: this.$i18n.t('message.change_success')
          }).then(() => {
            if(this.isAgency) {
              this.$router.push("/agency/jobOffer/" + this.jobId)
            } else {
              this.$router.push("/organization/jobOffer/" + this.jobId)
            }

          })

        }).catch(error => {
          console.log('this is org error', error)
        })
      }
      this.is_error = false
    }
  },
  mounted(){
    this.posting_start_date = Date.now()
    this.posting_start_time = "00:00"
    if(this.jobId != undefined){
      axios
      .get(process.env.VUE_APP_API + "/api/org/jobs/" + this.jobId, {headers: {'Authorization': 'Bearer ' + this.idToken}})
      .then(response => {
        console.log(response.data)
        this.registInfo = response.data

        if(response.data.facility != null){
          var facility_list = response.data.facility.split(',')
          this.room_capacity = facility_list[0]
          this.room_per_person = facility_list[1]
        }
        if(response.data.collection_fee != null){
          var fee_list = response.data.collection_fee.split(',')
          this.living_cost = fee_list[0]
        }

        if(response.data.access != null){
          var access_list = response.data.access.split(',')
          this.access_minute = access_list[0]
          this.access_way = access_list[1]
        }

        if(response.data.posting_time != null){
          var posting_start_time_list = response.data.posting_time.split(',')
          this.posting_start_date = posting_start_time_list[0]
          this.posting_start_time = posting_start_time_list[1]
        }

        if(response.data.posting_end_time != null){
          var posting_end_time_list = response.data.posting_end_time.split(',')
          this.posting_end_date = posting_end_time_list[0]
          this.posting_end_time = posting_end_time_list[1]
        }

        if(response.data.images != null & response.data.images != ""){
          this.registInfo.images = response.data.images.split(',')
        }else{
          this.registInfo.images = [null]
        }

        if(response.data.within_office_image != null & response.data.within_office_image != ""){
          this.registInfo.within_office_image = response.data.within_office_image.split(',')
        }else{
          this.registInfo.within_office_image = [null]
        }

        if(response.data.outside_office_image != null & response.data.outside_office_image != ""){
          this.registInfo.outside_office_image = response.data.outside_office_image.split(',')
        }else{
          this.registInfo.outside_office_image = [null]
        }

        if(response.data.working_image != null & response.data.working_image != ""){
          this.registInfo.working_image = response.data.working_image.split(',')
        }else{
          this.registInfo.working_image = [null]
        }

        if(response.data.employee_image != null & response.data.employee_image != ""){
          this.registInfo.employee_image = response.data.employee_image.split(',')
        }else{
          this.registInfo.employee_image = [null]
        }

        if(response.data.outside_dormitory_image != null & response.data.outside_dormitory_image != ""){
          this.registInfo.outside_dormitory_image = response.data.outside_dormitory_image.split(',')
        }else{
          this.registInfo.outside_dormitory_image = [null]
        }

        if(response.data.within_dormitory_image != null & response.data.within_dormitory_image != ""){
          this.registInfo.within_dormitory_image = response.data.within_dormitory_image.split(',')
        }else{
          this.registInfo.within_dormitory_image = [null]
        }

      }).catch(error => {
        console.log('this is org error', error)
      })
    }
    this.checkAgency()
    this.$store.commit('setLoading', false)
  }
}
</script>
<style scoped lang="scss">
.border-bottom{
  border-bottom: 1px solid #d6d6d6;
}

.employ_status_radio{
  border: 1px solid #ced4da;
  .custom-radio{
    min-width: 13rem;
  }
}

.salary_status_radio{
  border: 1px solid #ced4da;
  .custom-radio{
    min-width: 10rem;
  }
}

.tag_checkbox{
  border: 1px solid #ced4da;
  .custom-checkbox{
    min-width: 10rem;
  }
}
h5 {
  font-weight: 400;
  font-size: 1.2rem;
}
</style>
